module.exports = __webpack_public_path__ + "static/media/carousel-img02.48715a79.png";